import SmallSquareCards from "../../../../../utils/ReUsableComponents/SmallAndSquareReusableCards";
import Spinner from "../../../../../utils/Spinner";

const DomainOverview = (props) => {

  return (
    <>
      {props.domaindata?.domainLoading ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner
            text="domain"
          />
        </div>
      ) : (
        <SmallSquareCards domaindata={props.domaindata} name="Domain" tag="domains" />
      )}
    </>
  );
};

export default DomainOverview;
